const StackCardListing = (props) => {
  const {
    title,
    description,
    cards = [],
    additionalCTA,
  } = props;

  return (
    <section className="lg:tw-px-25 tw-p-8">
      <div className="tw-container">
        {title && (
          <h2 className="tw-font-roboto tw-text-4xl tw-font-bold tw-normal-case tw-mb-4">{title}</h2>
        )}
        {description && (
          <div className="tw-prose lg:tw-mb-10 tw-mb-8" dangerouslySetInnerHTML={{ __html: description }}/>
        )}
        
        <div className="">
          {cards.map(({fields}, index) => (
            <div key={index} className="lg:tw-flex tw-border tw-border-black/20 tw-shadow-md tw-mb-3">
              {fields.image?.url && (
                <img
                  src={fields.image.url}
                  alt={fields.image.label}
                  className="tw-w-full lg:tw-max-w-32 lg:tw-aspect-square lg:tw-object-cover tw-object-contain tw-object-top lg:tw-mr-2"
                />
              )}
              <div className="lg:tw-p-2 tw-p-4 tw-mr-4 tw-flex tw-flex-col tw-justify-center tw-flex-1">
                {fields.title && (
                  <h3 className="tw-font-roboto tw-font-bold tw-normal-case tw-mb-1">{fields.title}</h3>
                )}
                {fields.excerpt && (
                  <div 
                    className="tw-prose tw-mb-1 tw-leading-6"
                    dangerouslySetInnerHTML={{ __html: fields.excerpt }}
                  />
                )}
                {fields.cta?.text && (
                  <a
                    href={fields.cta.url}
                    target={fields.cta.target}
                    className="tw-font-roboto !tw-text-primary-red !tw-underline tw-text-sm"
                  >
                    {fields.cta.text}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        {additionalCTA?.text && (
          <a
            href={additionalCTA.url}
            target={additionalCTA.target}
            className="tw-block tw-mx-auto tw-bg-black tw-py-2 tw-px-6 tw-w-fit lg:tw-mt-14 tw-mt-8"
          >
            <span className="tw-text-white">{additionalCTA.text}</span>
          </a>
        )}
      </div>
    </section>
  );
};

export default StackCardListing;
